<script setup>
import {ref, reactive, onBeforeMount} from "vue"
import YTCard from "@/components/YTCard/YTCard.vue";
import {userInfoStore} from "@/store/store.js";
import {editNicknamePassword} from "@/api/nicknamePassword/nicknamePassword.js";
import {userLogoutHooks} from "@/hooks/user.js";
import router from "@/router/index.js";
const info = userInfoStore().info;

onBeforeMount(() => {
  // 获取当前用户昵称
  ruleForm.nickname = info.nickname
})

// 加载状态
const loading = ref(false)
// 表单锚点
const ruleFormRef = ref()
// 表单信息
const ruleForm = reactive({
  nickname: null,
  passwordOld: null,
  password: null,
  replyPwd: null
})
// 确认密码校验规则
const checkReplyPwd = (rule, value, callback) => {
  if (!value) return callback(new Error("请输入新密码"))
  if (value !== ruleForm.password) return callback(new Error("两次输入的新密码不一致"))
  return callback()
}
// 表单校验规则
const rules = {
  nickname: [
    {required: true, message: "用户名不能为空", trigger: "blur"}
  ],
  passwordOld: [
    {required: true, message: "原密码新不能为空", trigger: "blur"}
  ],
  password: [
    {required: true, message: "新密码不能为空", trigger: "blur"}
  ],
  replyPwd: [
    {required: true, validator: checkReplyPwd, trigger: "blur"}
  ]
}
// 取消新增
const cancelAdd = () => {
  router.back()
}

// 保存校验表单
const submit = async () => {
  await ruleFormRef.value.validate(async (valid, field) => {
    if (valid) {
      let param = {
        nickname: ruleForm.nickname,
        passwordOld: ruleForm.passwordOld,
        password: ruleForm.password
      }
      await editNicknamePassword(param)
      // 修改成功重新登录
      ElMessage.success("密码修改成功，请重新登录")
      userLogoutHooks()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}

</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      :validate-on-rule-change="false"
      size="large">
    <YTCard :title="'我的信息'" :is-show-divider="false">
      <template #container>
        <el-form-item label="用户名：" prop="nickname">
          <el-input style="width: 350px" v-model="ruleForm.nickname" maxlength="30" show-word-limit placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="原密码：" prop="passwordOld">
          <el-input style="width: 350px" type="password" v-model="ruleForm.passwordOld" maxlength="16" show-password placeholder="请输入原密码"></el-input>
        </el-form-item>
        <el-form-item label="新密码：" prop="password">
          <el-input style="width: 350px" type="password" v-model="ruleForm.password" maxlength="16" show-password placeholder="请输入新密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码：" prop="replyPwd">
          <el-input style="width: 350px" type="password" v-model="ruleForm.replyPwd" maxlength="16" show-password placeholder="请输入密码"></el-input>
        </el-form-item>
      </template>
    </YTCard>
  </el-form>
  <v-row>
    <v-col cols="4">
      <v-row>
        <v-col cols="6">
          <v-btn @click="cancelAdd">取消</v-btn>
        </v-col>
        <v-col cols="6">
          <v-btn color="primary" @click="submit" :disabled="loading">保存</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped>

</style>
